export interface IExternalVouchersState {
  externalVouchers: IExternalVoucher[];
}

export interface IExternalVoucher {
  voucherCode: string; // Voucher code
  status: VoucherValidity; // Status code (use VoucherValidity enum)
  statusName: string; // Status name
  originalRemainingValue: number; // Remaining value on the voucher, Library returns it in main currency we multiply it by 100 because we count cents
  partiallyRedeemable: boolean; // Whether partial redemption is allowed
  currency: string; // Currency of the voucher
  orderSessionId: string; // Order session ID
  currentSessionVoucherConsumption: number; // Current session voucher consumption, Library returns it in main currency we multiply it by 100 because we count cents
  voucherId?: string; // Voucher ID
  voucherService: number; // Voucher service (use VoucherService enum)
}

export enum VoucherService {
  SMEETZ = 1,
  INCERT = 2,
}

export enum VoucherValidity {
  NotFound = 0,
  Valid = 1,
  FullyRedeemed = 2,
  Canceled = 3,
  Expired = 4,
  Unknown = 99,
}

export interface VoucherStatusResponse {
  status: number; // Status code (use VoucherValidity enum)
  remainingValue: number; // Remaining value on the voucher
  partiallyRedeemable: boolean; // Whether partial redemption is allowed
  currency: string; // Currency of the voucher
}
